import styled, { ITheme } from 'styled-components';

export const Wrapper = styled.div`
    width: 100%;
    margin: 0 auto;
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    padding: calc((1440px - 1272px) / 2);
    max-width: 1440px;
    padding-bottom: 260px;
    overflow: hidden;

    .left-introduce {
        width: 100%;
        .to-idea {
            margin-top: 20px;
        }
        .earn-up {
            margin-top: 32px;
            margin-bottom: 22px;
            max-width: 414px;
            color: ${({ theme }: { theme: ITheme }) => theme.text2};
        }

        .list-btn {
            margin-top: 10px;
            button {
                background: transparent;
                border: 1px solid ${({ theme }: { theme: ITheme }) => theme.border3};
                border-radius: 4px;
                color: ${({ theme }: { theme: ITheme }) => theme.text1};
                margin-right: 10px;
                padding: 9px 20px;
                height: auto;
            }
        }
    }
    .right-introduce {
        position: absolute;
        top: 0;
        left: calc((1440px - 1272px) / 2 + 160px);
        z-index: -1;
        width: 100%;
        // width: 60%;
        img {
        }
    }

    ${({ theme }: { theme: ITheme }) => theme.mediaWidth.upToMedium`
        flex-wrap: wrap;
        flex-flow: column-reverse;
        padding: 0 12px;
        .left-introduce {
            position: relative;
            z-index: 1;
            margin-left: 0;
            margin-top: -30px;

            .get-early, .to-idea {
                margin-top: 0;
                width: 50%;
                svg {
                }
            }
            .to-idea  {
                margin-top: 10px;
            }
            .earn-up  {
                margin-top: 10px;
                font-size: 14px;
            }
        }
        .right-introduce {
            position: relative;
            z-index: 0;
            left: 0;
            margin-top: 40px;
        }
    `}
`;
